import { Record, List } from "immutable";

const SitesStateRecord = Record({
  currentData: List(),
  compareData: List(),
  loading: false,
  error: null
});

export default SitesStateRecord;
